import { API } from 'utils/api/api'
import { formatRequestStringV2 } from 'utils/helpers/api/formatRequestStringV2'

type FetchRequestsPerRightParams = {
  orgCode: string
  reportType?: string
  startDate: string
  endDate: string
  policyScope?: string
  dataSubjectType?: string
  dataRole?: string
  rightCode?: string
  applicationCode?: string
}

export const fetchRequestsPerRight = (params: FetchRequestsPerRightParams) => {
  const {
    orgCode,
    reportType,
    startDate,
    endDate,
    policyScope,
    dataSubjectType,
    dataRole,
    rightCode,
    applicationCode,
  } = params
  return API.get<any>(
    formatRequestStringV2({
      entityUrl: `/api/organizations/${orgCode}/right-stats/historical/requests-per-right`,
      params: {
        filters: {
          startDate,
          endDate,
          ...(reportType && { reportType }),
          ...(policyScope && { policyScopeCodes: policyScope }),
          ...(dataSubjectType && { dataSubjectTypeCodes: dataSubjectType }),
          ...(dataRole && { dataRole }),
          ...(rightCode && { rightCodes: rightCode }),
          ...(applicationCode && { applicationCodes: applicationCode }),
        },
      },
    }),
  )
}
